import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleHipobuy from "../pages/article-hipobuy/page";
import ArticleAvantages from "../pages/article-avantages/page";
import ArticleMigration from "../pages/article-migration/page";
import ArticleSecurite from "../pages/article-securite/page";
import ArticleProductivite from "../pages/article-productivite/page";
import ArticleEcommerce from "../pages/article-ecommerce/page";
import ArticleAlternatives from "../pages/article-alternatives/page";
import ArticleNouveautes from "../pages/article-nouveautes/page";
import ArticleTemoignages from "../pages/article-temoignages/page";
import ArticleFutur from "../pages/article-futur/page";
import GuideAchat from "../pages/guide-achat/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/hipobuy-spreadsheet-guide-complet",
    element: <ArticleHipobuy />,
  },
  {
    path: "/article/hipobuy-spreadsheet-avantages",
    element: <ArticleAvantages />,
  },
  {
    path: "/article/hipobuy-spreadsheet-migration",
    element: <ArticleMigration />,
  },
  {
    path: "/article/hipobuy-spreadsheet-securite",
    element: <ArticleSecurite />,
  },
  {
    path: "/article/hipobuy-spreadsheet-productivite",
    element: <ArticleProductivite />,
  },
  {
    path: "/article/hipobuy-spreadsheet-ecommerce",
    element: <ArticleEcommerce />,
  },
  {
    path: "/article/hipobuy-spreadsheet-alternatives",
    element: <ArticleAlternatives />,
  },
  {
    path: "/article/hipobuy-spreadsheet-nouveautes",
    element: <ArticleNouveautes />,
  },
  {
    path: "/article/hipobuy-spreadsheet-temoignages",
    element: <ArticleTemoignages />,
  },
  {
    path: "/article/hipobuy-spreadsheet-futur",
    element: <ArticleFutur />,
  },
  {
    path: "/guide-achat",
    element: <GuideAchat />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;